import { FC, TextareaHTMLAttributes, Ref } from 'react'
import { cn } from '../../utils/cn'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean
  ref?: Ref<HTMLTextAreaElement>
}
export const Textarea: FC<TextareaProps> = ({
  className,
  hasError,
  ref,
  ...rest
}) => {
  const textareaClassName = cn(
    'relative flex rounded-md border border-gray-300 bg-white px-3 py-2 transition-colors duration-300 focus-within:border-blue-600 focus-within:ring-2 focus-within:ring-blue-300 focus:outline-none',
    {
      '!text-red-600': hasError
    },
    className
  )
  return (
    <textarea
      ref={ref}
      className={textareaClassName}
      rows={4}
      {...rest}
      aria-invalid={hasError}
    />
  )
}
